import { Alert } from "@mui/material";

export type AlertError = {
    detail: string;
    type: string;
};

type ImportErrorAlertWidgetProps = {
    error: AlertError;
};

function ImportErrorAlertWidget(props: ImportErrorAlertWidgetProps) {
    return (
        <Alert severity="error" sx={{ whiteSpace: "pre-wrap" }}>{props.error.detail}</Alert>
    );
}

export default ImportErrorAlertWidget;